import _t from 'i18n!nls/promotions';

type PromotionSeoProperties = {
  promoCode: string;
  title: string;
  description: string;
};

export const getPromotionSeoProperties = (promoCode: string): PromotionSeoProperties | undefined => {
  const infoList = [
    {
      promoCode: 'wellness-free-courses',
      title: _t('Free Online Mental Health and Wellness Courses'),
      description: _t(
        "From de-mystifying mindfulness to understanding the science of happiness, we're making popular wellness courses available for free."
      ),
    },
    {
      promoCode: 'public-health-free-courses',
      title: _t('Free Public Health Courses During COVID-19 Outbreak'),
      description: _t(
        "From the science behind COVID-19 to communicating during global emergencies, we're making popular public health courses completely free."
      ),
    },
    {
      promoCode: 'free-courses-high-school',
      title: _t('Free Online Courses for High School Students'),
      description: _t(
        'From calculus to guitar for beginners, we want to help high school students everywhere keep learning. Start learning for free!'
      ),
    },
    {
      promoCode: 'free-courses-college-students',
      title: _t('Free Online Courses for College Students'),
      description: _t(
        "From interview prep to learning data science, we've collected courses to make it easier to keep learning. Start learning for free!"
      ),
    },
    {
      promoCode: 'career-development-free',
      title: _t('Free Online Courses for Career Development'),
      description: _t(
        'From creative problem solving to leading the company of the future, here are courses to navigate the changing world of work. Start learning for free!'
      ),
    },
    {
      promoCode: 'cloud-technology-free-courses',
      title: _t('Free Cloud Technology Online Courses'),
      description: _t(
        "From machine learning to cloud computing, we've curated a set of courses to help you grow your career in an increasingly digital world. Start learning for free!"
      ),
    },
    {
      promoCode: 'cursos-gratis-covid-19',
      title: 'Cursos Gratuitos Durante el Brote de COVID-19', // Do not translate this
      description:
        'Desde cursos de bienestar a cursos de desarrollo profesional, estamos haciendo cursos populares en español disponibles gratuitamente.', // Do not translate this
    },
    {
      promoCode: 'free-certificate-courses-in',
      title: _t('Free courses for learners in India'),
      description: _t(
        'Earn a free certificate from experts at Google Cloud, Amazon, the University of Michigan, and more. Build new skills, grow your career, and expand your knowledge with this special course collection.'
      ),
    },
    {
      promoCode: 'fifty-off-industry-experts',
      title: _t('Save 50% and learn from industry experts'),
      description: _t(
        'Learn in-demand job skills from the experts who use them every day. Build expertise in data science, IT, business, cloud computing, and more with industry leaders like Google, IBM, Unity, and HubSpot.'
      ),
    },
  ];
  return infoList.find((info) => info.promoCode === promoCode);
};
